<template>
  <right-menu-item
    @click.prevent="click"
    :class="{'!text-red-600': !loading && isActive, 'muted': !isActive}"
    :text="$t('Delete permanently')"
    :loading="loading"
    icon="trash"
  />
</template>

<script>
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import DocumentStore from '@/frontapp/mixins/DocumentStore'
import deletePermanently from '../../mixins/actions/DeletePermanently'
import { showConfirm } from "../BcConfirm";
import { trackEvent } from '../../gtm'

export default {
  mixins: [DocumentStore],
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    isActive () {
      return true
    },
    ...mapStores(useBcSelectedStore),
  },
  methods: {
    async click() {
      const confirm = await showConfirm({
        header: this.$t('Do you want delete this document?'),
      })

      if (!confirm) {
        return
      }

      this.loading = true
      await deletePermanently([this.bcDocumentStore.document.id], [])
      this.loading = false
      trackEvent(this.$route.matched[0].name, 'deleteFromTrash')
      await this.$router.replace('/trash/0/0')
    }
  }
}
</script>

<style lang="scss" scoped></style>
